import Vue from 'vue'
import Child from './Child'

// Base

import Spinner from './spinner/Spinner'
import Page from './Page'

// Form

import VField from './form/VField'
import VCheckbox from './form/VCheckbox'
import VDisplay from './form/VDisplay'
import VInput from './form/VInput'
import VFile from './form/VFile'
import VSelect from './form/VSelect'
import VRadio from './form/VRadio'
import VRadioButtons from './form/VRadioButtons'
import VDatetime from './form/VDatetime'
import VAutocomplete from './form/VAutocomplete'
import VButton from './form/VButton'
import VSubmit from './form/VSubmit'

// Front

import Banner from './front/Banner'
import Banners from './front/Banners'
import Buttons from './front/Buttons'
import Card from './front/Card'
import Carousel from './front/Carousel'
import Comments from './front/Comments'
import IFrame from './front/IFrame'
import Image from './front/Image'
import Rating from './front/Rating'
import Row from './front/Row'
import RowGroup from './front/RowGroup'
import Tabs from './front/Tabs'
import Title from './front/Title'

// Components that are registered globaly.
[
    Spinner,
    Page,
    Child,
    Banner,
    Banners,
    Buttons,
    Card,
    Carousel,
    Comments,
    IFrame,
    Image,
    Rating,
    Row,
    RowGroup,
    Tabs,
    Title,

    VField,
    VCheckbox,
    VDisplay,
    VInput,
    VFile,
    VSelect,
    VRadio,
    VRadioButtons,
    VDatetime,
    VAutocomplete,
    VButton,
    VSubmit,
].forEach(Component => {
    Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js